
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Jasno`,
'deleteKey': `⌦ Izbriši`,
'downKey': `↓ Navzdol`,
'endKey': `⤓ Konec`,
'enterKey': `Vnesite`,
'escapeKey': `⎋ Pobeg`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Ustvari 
          <code>LICENCA 
          </code> datoteko 
        `,
'homeKey': `⤒ Domov`,
'keyCommand': `⌘ Command/Win`,
'keyControl': `^ Nadzor`,
'keyOption': `⌥ Možnost/Alt`,
'keyShift': `⇧ Premik`,
'leftKey': `← Levo`,
'pagedownKey': `▼ Pogled navzdol`,
'pageupKey': `▲ Stran navzgor`,
'rightKey': `→ Desno`,
's00065e45db8c0441': `Za več podrobnosti glejte Orodja za razvijalce`,
's001dd78415a91fa0': `Žleb drsne vrstice`,
's002fa7d1054ed082': `Okvirno polje`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazahstanski`,
's01b56d233c6c5cac': `Sekcioniranje`,
's01d32b35baa3b676': `Avtor`,
's02106cc2ef0e7578': `Nov zatič...`,
's02ab1ea8e5100fc1': `označite izbiro kot "dvosmerno razveljavitev".`,
's0312976fe9da5951': `Gumb`,
's03608a32f05eded2': `Približevanje s stiskom`,
's036d35e03be98d22': `Matematična globina`,
's037b1dc850a89273': `Nadomestni pod`,
's0396202b716732ec': `Označite izbor kot prečrtan`,
's03f49e598ffb11cc': `Poljski`,
's0448f1059fa01720': `Shranite, delite ali natisnite raziskovalno nalogo. Uredite informacije, kot so naslov, jezik ali licenca.`,
's0458872c43beadef': `Vstavite vrstico pred`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Razmik med besedami`,
's05e9759cfd99c48f': `Utemeljite`,
's063fa5a0a4903bf4': `Vstran, od leve proti desni`,
's064339c229374050': `Kodiranje`,
's06634274f19b0572': `Izbira nožic`,
's06743b24499f0035': `Sidrni center`,
's07808b0ca6da8fef': `Ograjena spletna stran`,
's07970793b21351fd': `Osnovna posoda Ruby`,
's079cf7850d9327f0': `Pisava`,
's07aa10850d9ddcc7': `Obrazec`,
's07e6118e838b2e23': `Navigacija`,
's0816468df86e4036': `Odpre nastavitve`,
's082869038c117fe5': `portugalščina (Brazilija)`,
's086e6c267ade2609': `Nasičenost`,
's08e12ade32ef8125': `Setsvana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Vstavljanje seznama (neurejenega)`,
's09c3f1d21de14ae1': `Izbor označite kot podčrtan`,
's0a2d91c6720033e9': `Obrezovanje razmika med besedilom`,
's0a3ddcba94027d95': `Prileganje predmeta`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Vstavljanje navigacije`,
's0a7db790db1fc45c': `Izbor označite kot razpon`,
's0b1271f50a77dc73': `Polje za vsebino`,
's0b24d08ea349b455': `Vse, kar lahko vstavite. Na začetku so neinteraktivni elementi, kot so seznami ali slike, nato pa interaktivni elementi, imenovani gradniki. Nove lahko dobite s klikom na iskalno vrstico.`,
's0bdca49248ba4820': `Bližnjice`,
's0befccf152b6c0a9': `Orient iz metapodatkov`,
's0c11e479416c8421': `Vstavite napis tabele`,
's0c27336067c59611': `Podloga za pomikanje`,
's0c4593d81f147042': `Osnovni`,
's0c4b2e98d4ab7f5a': `Ukazi aplikacije`,
's0c883713b83616a8': `Shranite aktivni dokument`,
's0ca5c0460199cba1': `Okrajšava`,
's0cf10c4f40588f8d': `Naslov tabele`,
's0d86afa3c6a1e28b': `Smer gibanja`,
's0dad143dff0079fc': `Malajalam`,
's0db05bd7ba6fff96': `Vaš dokument, ki ga je mogoče raziskati. Tu lahko pišete besedilo, kopirate/prilepite, urejate itd.`,
's0dc452999c129e15': `Omogoči ponovno nalaganje v živo`,
's0de0febab8a4beaf': `Napaka pri branju tega paketa`,
's0e44968489e076a8': `Kitajski`,
's0e4862e87c7d53ce': `Izbor označite kot citat`,
's0e6ea8870dbddab2': `Ukazi za dokumente`,
's0ee28503778e4c0c': `Zadnja izhodiščna vrednost`,
's0ef01c03299bbb83': `Dekoracija`,
's0f17f32919661cff': `Mongolski`,
's0f350bc4e538e3ea': `Besede`,
's105a06836c40fcb4': `Nastavite filtre, barvo in mešanje izbranih elementov`,
's106b274b5af798e5': `Stavki`,
's1082e1649793dca9': `Izbor označite kot opredeljen izraz`,
's10f3845975a0351e': `Urejanje metapodatkov`,
's1125d159f7e64df5': `Prikaz`,
's11326fd2590f4e5e': `Privzeto`,
's1155ec07a221e739': `Premikalna vrstica`,
's1173bf7a3e0b74c9': `Najmanjši (y)`,
's1177237a3e0e548c': `Najmanjši (x)`,
's1219d97b49650c05': `Vidljivost`,
's123bea44f38abccf': `Vstavljanje predmeta`,
's1245e2cb9f20197e': `Uskladitev`,
's12946ec1b850962c': `Vstavljanje stolpca za`,
's1351209ef74ee729': `Razpon vseh stolpcev`,
's13c60cb409e8cb6f': `Poravnajte središče`,
's13ebd619c8a06a6d': `Mreža samodejnih vrstic`,
's13ef8ca26ca8861b': `Element za rezanje`,
's151bc2eea7a032a4': `-spremenjeno -`,
's153bc3c3aa39587b': `Glava mize`,
's156647179b21d351': `Vstavite telo tabele`,
's158b6ec6b1fffcb2': `Prekinitev po`,
's15d0c0657c1ee08c': `Ključ API`,
's1626a7e10a9f9dcc': `nastavi družino pisave izbora`,
's1637c7d1a30629e2': `Polje za mejo`,
's1641ab440bf4daa4': `Posodobitev tega paketa gradnikov`,
's166bd56d19670a72': `Povečanje`,
's1696c76a23c0834e': `Napredno: V upravitelju paketov prikažite pakete z različicami, kot je 0.x.x`,
's16b9446e3a70e1f4': `Atributi`,
's16f205466761e583': `Brez optičnega določanja velikosti pisave`,
's16f2f1c2c516d307': `Odprite dokument`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Licenca`,
's17bfaaa4e7528bc7': `Baškirski`,
's17fb3f4805f4f4b9': `Odstranitev polja`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Ustvari paket`,
's18d5c44aae3dc82a': `Spletno pri urejanju`,
's1988d71ef8060edf': `Vstavite vrstico tabele`,
's19abee1277c9bca2': `Samoanski`,
's19daf2f26c19543d': `Osnutek`,
's1a1acc902e6668e0': `Prikaži napredno oblikovanje besedila`,
's1a5230a71d9285c1': `Zajem`,
's1aa1cb63ad44bc6f': `Vrzel v stolpcu`,
's1af8b67d1c85c811': `Prostor med`,
's1b4a36fce2456660': `Družina pisav`,
's1c246045629b0016': `označite izbor kot izbris`,
's1c3fc313a9184670': `Javna povezava`,
's1c65f5004a07dcfa': `škotska gelščina`,
's1c690963f1e2df00': `Videz, prilagojen posamezni platformi`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Želite kratek voden ogled?`,
's1d19244f549ec535': `Izobraževanje`,
's1d5c7b28e8b50d6d': `Izredni diplomirani inženir.`,
's1db591f5a54dbfd3': `Polje za vsebino`,
's1dbb9f50e16c92a3': `Polmer meje`,
's1dfb744260fb3a01': `Bidirekcionalna izolacija`,
's1e9c2c654732cc5f': `Belorusija`,
's1eaccbf2d6af8ab5': `Informacije`,
's1efbfc3937d565bd': `Ozadje`,
's1f2b49c1bca2035d': `Katalonščina`,
's1f74bdf32b51a5fc': `Slika v ozadju`,
's1f7698c061c208c9': `Odpri`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korzičani`,
's21d61916eb8d137d': `Telo mize`,
's21d723a1dbcd89c8': `javanščina`,
's21f8a2eaf5a70749': `Vstavljanje nalepke`,
's2206c42e5b835e6e': `označite izbiro kot okrajšavo`,
's22a2348c46a912a0': `Vstavljanje razdelka`,
's233ae776268cd44b': `Poslovni`,
's236ed7ba747099b0': `Teža pisave`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Besedilo`,
's24949d7adbb5a098': `Zbirka orodij`,
's252a52330d32b900': `Metapodatki`,
's2540844a4bc4d9ba': `Zahtevate navedbo avtorstva?`,
's255857544a9d5ec0': `Ponastavitev`,
's255c77900f2b5e0f': `Barvna shema`,
's256ab831a48c941c': `Odstrani vse oblikovanje besedila iz izbora`,
's2591806d7b222591': `Ponastavitev sprememb`,
's25e1a07e454c2c11': `Mreža`,
's262abbaf1d05f009': `Mehka svetloba`,
's266935f2447fcd98': `Nad levo`,
's268ecd1cef45a9a8': `Ste prepričani?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Olajšajte`,
's27076e66c5d483ba': `Navpična poravnava`,
's2712dc5641a33226': `Računi paketnih registrov so namenjeni razvijalcem in omogočajo konfiguracijo enega
          ali več registrov.`,
's27cc88818cc46ff6': `Stabilen`,
's281d957112b10f12': `Neposredno urejanje HTML dokumenta`,
's28b6246ce616a548': `Vstavljanje skupine stolpcev tabele`,
's29a1c26521879b9f': `Zmanjšanje obsega`,
's29acfd2778e8c377': `Skrijte napredno oblikovanje besedila`,
's29b24c06315e9343': `Vstavljanje vhoda`,
's29eb103449472e3b': `Vstavite naslov (raven 3)`,
's29ee7434494a0dfe': `Vstavite naslov (raven 2)`,
's29f21c34494d614d': `Vstavite naslov (raven 1)`,
's29fbfc3449557f72': `Vstavite naslov (raven 6)`,
's29ff743449588131': `Vstavite naslov (raven 5)`,
's2a031834495bcdb4': `Vstavite naslov (raven 4)`,
's2a75c946ef4dcab7': `Različni`,
's2b2ae20d26f78ac2': `Blok`,
's2b8f50c64be440f7': str`Izberite 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Naročilo`,
's2bad2d24def4aa0b': `Prekinitev vrstice (jezik CJK)`,
's2ceb11be2290bb1b': `Prekliči`,
's2ced8e8fafb499f6': `Brisanje elementa`,
's2d986d31f8d67357': `Vstavljanje niza polj`,
's2d995a37cf5e4995': `Vstavite NoScript`,
's2de969afacdaa7a6': `Oblika`,
's2df075aface0dab8': `Delite`,
's2e192b19ed15fcf6': `Stran`,
's2e39b99cf23606fa': `Nastavitev postavitve izbranih elementov`,
's2e4818861000b13f': `Postavitev`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Prelivanje (y)`,
's2edd6688a65e21f0': `Prelivanje (x)`,
's2f0bcdffc92a786b': `Plavajoča desnica`,
's2f2044f2431a32d5': `Naslov`,
's2f4d4bfbc466d91f': `Albanski`,
's2f8da2cb5f236588': `Ime vašega paketa. Mora biti razširjeno, npr. \`@org/pkg\`. `,
's30cce87854901922': `Predšolski vrtec`,
's3124653c272f054c': `Barva pravila stolpca`,
's314a4f7685c8e824': `Vedno`,
's31c06e226322f065': `Izogibajte se sirotam`,
's323dcde72b850272': `Javni dostop`,
's32911e52ee8ac745': `Vstavite režo`,
's337a1e9022a8d19f': `Tabela`,
's33c1450d2822bb0f': `Vstavite napis slike`,
's33c18d5a4cbffa2a': `Irski`,
's33f85f24c0f5f008': `Shrani`,
's342b0cabfa672822': `Pomagajte uporabniku najti vaš pripomoček`,
's3437e0d9899e7ae1': `pošiljanje telemetričnih podatkov o vaši uporabi programa WebWriter.`,
's344ea8f4939cdc98': `Barva`,
's34dcda3b0f9d5a98': `Toggle url`,
's34f724979a124c50': `nastavi barvo ozadja izbranega besedila`,
's355b21b89ce5d9c5': `Podrobnosti`,
's35ae5f4e0fa2777b': `Poravnava po meri`,
's35aeaff1425bca9e': `WebWriter ne podpira medijev tipa `,
's35c3125c7750681e': `Blokovni citat`,
's3643189d1abbb7f4': `Koda`,
's3649bacefe731bf6': `Orodjarna Toggle`,
's365280e16a8ea32d': `Kopiranje izbora`,
's366991b9c9287765': `Desno`,
's36a194e38d653a26': `Anotacija podatkov`,
's36b3cefdcb897f15': `Perspektiva`,
's372fae706048ce41': `Parno`,
's377e24af9628c37e': `Naročeni seznam`,
's37a8c35f6581da5f': `Brez sidra`,
's37fa3b9cd51c2dfd': `nastavi velikost pisave izbora`,
's380d17664bb69531': `Vstavljanje stolpca pred`,
's3815184eb09f0dcf': `Kurzor`,
's382a2aa3984474dd': `Ustvarite spletno stran`,
's38980f98cb07ceb8': `Aktivni dokument shranite kot kopijo`,
's3914cb410fca44d4': `Uvoz`,
's3a179f6db2972384': `Položaj Ruby`,
's3a5ca02f282d247e': `Delite...`,
's3ae67088bbefba98': `Paketi`,
's3b0ab4b52326316f': `Svetloba`,
's3b3ea038c5d3bb06': `Oddelek`,
's3bdad99768e11911': `Raziskovalna`,
's3cb47df8290fa94c': `Vstavitev možnosti`,
's3cf89cb47fdde7e9': `Povezava`,
's3d09398e555ee5f9': `Napredne možnosti`,
's3d249bb480032121': `Seznam`,
's3d3efd1e19bdcfb4': `Opombe datuma/časa`,
's3d6a732c792ccb9e': `Anotacija Ruby`,
's3d93f9ea0c5a13fa': `Slika`,
's3d9548e211b958ce': `Preskočite prekrivanja`,
's3e092e9d1ee2c5bb': `Klip`,
's3e78ddc9a48a608d': `Lepo`,
's3eb6d1e6e79ed7c4': `Ni najdenih dokumentov`,
's3eca5a034978754b': `Brisanje izbora`,
's3f06e9abb6ebcb79': `Znaki`,
's3f1e7a3f2b283d3b': `Marža`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Vstavite članek`,
's3fd83566dd643d10': `Vstavljanje legende`,
's3fe72792941c18f9': `Spodnji del besedila`,
's3ffcdc5db5e7d0c5': `Obratno`,
's40e3826b7f74a3b5': `Pan (desno)`,
's40f07d7859284a44': `Prevladujoče izhodišče`,
's4101ada154a1b958': `Sredina`,
's410c465a5993f82d': `Priložnost za prekinitev vrstice`,
's41322d19c928c603': `IKT`,
's417b90913e05bc17': `Predogled`,
's418f2020fe996832': `Potrdite spremembe`,
's41c724f0698148e9': `Označite izbor kot bližnjico na tipkovnici`,
's41f65a763f8e44ab': `Skupina glave tabele`,
's42721130228841b0': `Polje za udarce`,
's429bd646f1cf8bc6': `Računi Grammar LLM vam omogočajo uporabo vmesnika API Grammar LLM za popravljanje slovnice v besedilu.`,
's429dd933ba95549b': `Vstavite naslov`,
's42e470ef1d707a28': `Samodejno predvajanje`,
's42ffdab1291fb3de': `Vstavite vrstico za`,
's430831017f3f0499': `Nagib (y)`,
's430bd5017f42511c': `Nagib (x)`,
's433ba70286202ceb': `Prekinite vse`,
's441b20a8a50e36b4': `Makedonski`,
's445b8acb9206db6e': `Zavrzite in prekličite`,
's446a924922651ea0': `Poudarek besedila`,
's44cdba92713de38e': `Območje mreže`,
's45518abd911471d0': `Hrvaška`,
's456a8d744313852a': `Prostor okoli`,
's4634541f5056a546': `Abhazija`,
's46d4abe6255cb9e1': `Ponovna dodelitev bližnjice`,
's4730c232e7209c40': `Obrezovanje obeh`,
's474f0eec369d02a4': `Izhodni vzorec`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `označite izbor kot opombo datuma/časa`,
's47ebf3a8fb3b10c1': `Orientacija`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Možnost`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Senca besedila`,
's4993444bfd3f3e5e': `Zbijanje`,
's49ad24935b14e3df': `Kečua`,
's49c560aecfeb8c29': `Maska`,
's49dd67aed00029ef': `Matematika`,
's49e763aed00877a8': `Glavna stran`,
's4a894f57eba1cf1e': `Bližnjica na tipkovnici`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Trda svetloba`,
's4b2c143acf931122': `Višina črte`,
's4b58c01e2578f5e4': `Legenda`,
's4bbff4e008690da1': `Izogibajte se strani`,
's4c1535f316305a2a': `Preverite izbor`,
's4c402ff5355fd310': `Obojestranski preklic`,
's4caed5b7a7e5d89b': `Angleščina`,
's4cb38675a21b2c98': `Nepodprta vrsta lastnosti '\${desc.type}' (obdelava kot JSON)`,
's4cc8391f172c0cdf': `Opustite ogled`,
's4d528b416ac8dee2': `Vstavljanje skupine naslovov`,
's4d546f6c87128d5b': `Najprej prostor`,
's4dcb9315f6527f9c': `Zaženi ob ponovnem nalaganju`,
's4e191bdb4700a6e9': `Previjanje (x)`,
's4e1c7fdb470386ac': `Premikanje po zaslonu (y)`,
's4e2562fe3990e621': `Napaka pri povezovanju`,
's4e361bf8eef3759a': `Prekinitev besede`,
's4ea0f21fc2a338a1': `Premaknite se navzgor`,
's4eace13b3ed74187': `Stranski komentar`,
's4efee5b48a4593cb': `Zanka`,
's4f26e7cb7c0a8318': `Vektorska risba`,
's4fd2e638aabb0bb3': `WebWriter podpira vstavljanje številnih različnih virov. Preprosto prilepite
          povezavo do vsebine iz:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Thai`,
's5015a8fb33b98872': `Tanek`,
's50489ffb1bde152e': `Vstavljanje`,
's5068560b8d39663d': `Zemljevid s klikom`,
's517acbf1f96324f9': `Teža`,
's523eb9043213ff0d': `Kurzivna pisava`,
's52777d434baeed9b': `Vstavite kazalnik napredka`,
's52af5d7ac34c2163': `Vrstica tabele`,
's52e0bdc3ee304436': `Vstavite števec`,
's531056f039febd39': `Vstavite izbor`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `Odprite ali zaprite orodjarno (samo na ozkih zaslonih, sicer je orodjarna vedno vidna na strani).`,
's5432ad3c84273229': `Slika`,
's543906d1db8b2283': `Uredi `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodža`,
's54897f2764b0e4d0': `Namestitev tega paketa pripomočkov`,
's54cbfaf2a8da7818': `Paštunščina`,
's550839f3e4e205bb': `Izbor označite kot zelo pomemben.`,
's55905c735052d295': `Tematski odmor`,
's5590dbf7e425789d': `Oznaka`,
's5623aa2f83b05c76': `Tibetanski`,
's564d1648b1ceee9f': `Ažurno`,
's565cd5ffb0158c46': `Izogibajte se regiji`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Pojdi nazaj`,
's5787c6d5b3b5541a': `Pot posnetka`,
's579c69f419b6caef': `Gladko`,
's587ac858dd80f6fa': `Podnapis`,
's58bec0ecd4f3ccd4': `Strogo`,
's59404f5593c32fdc': `Kerning pisave`,
's5941292bb77281ab': `norveški bokmål`,
's599dcd2472c75c19': `Odstavek`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Izbor označite s podatkovno opombo`,
's5a356677b61a6b7e': `Moldavija`,
's5b474b5c0ac0c7c4': `Skupina stolpcev tabele`,
's5b517ac216f9ee62': `Stranski`,
's5b8cc9bb61ddce15': `Vstavite odstavek`,
's5bba2ac2e53bd1fd': `Kirgiz`,
's5be80ad6b8301710': `Vrstni začetek`,
's5c1ecf88259b79f9': `Predstavitev`,
's5c2a1a52c0389c30': `Inženiring`,
's5c63af7695445fcf': `Slog besedila`,
's5d18ca4c3111be6f': `Vstavite glavo tabele`,
's5d87c1e588f48d90': `Praksa`,
's5d929ff1619ac0c9': `Iskanje`,
's5da52af9b083c29a': `Model`,
's5dc77784260a7236': `samodejno`,
's5e27738a2e8eb763': `Prijavite se`,
's5e2cba97c0d971bd': `Ponovno polnjenje paketov`,
's5e53415a6d5719ad': `Družbene vede`,
's5e6a7a0c30d2a270': `Preskoči prekrivanja (samodejno)`,
's5e9e8e4d21bafedc': `Proizvodnja hrane`,
's5ed03bb1f3a15949': `Slika`,
's5f43af3669b1e098': `Vir:`,
's5feaf7fd7ee567c8': `Beseda preloma`,
's600fd23c9ce971e8': `Tiskanje aktivnega dokumenta`,
's602bbd28dae2c60f': `Samodejni zagon`,
's60ff598dfcf2c773': `Pod pravico`,
's61053f0e3ebbd272': `normalno`,
's613c6ff83883c04f': `Stolpec tabele`,
's6196153c4b0c1ea0': `Namestitev`,
's61c017f6d5c303af': `Frizijščina`,
's61ded17ca3f48c82': `Odmik podčrtane črte`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Izbira kopiranja`,
's624e31cd4f1b89d4': `Gladko pomikanje`,
's626daf42b1ab7df7': `Poravnajte na levo`,
's6280bf993915c57a': `Rob premikanja`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Opis`,
's63dfc5b1c1c27849': `Jidiš`,
's63e03c70f67ebf9c': `Kontekst`,
's63e71d20d1eaca93': `Nemščina`,
's640bc7710d0143ce': `Ponovitev zadnje razveljavljene spremembe v aktivnem dokumentu`,
's64dc1fc7e3db45c9': `Ustvari nov dokument`,
's65ac276544ba33cd': `Datoteka SVG`,
's66765c420ee578e4': `Enakomeren prostor`,
's669b18c6d2d9c95b': `Ni`,
's6747dbf4ad6063ba': `Samostojni konec`,
's6787497df07fa97e': `Lahko se pomaknete čez postanke`,
's67c2b60a506a09e4': `Srednja izdaja.`,
's680bd4d926cd5a84': `Ohraniti 3D`,
's6827930ef1aeaf99': `Osnovni URL`,
's684a16f3c711394d': `Nad desno`,
's687e27f036a71b32': `Izolat`,
's68b87d7b61052dc3': `Vrstica tabele`,
's68e0e3a2bab7ce3e': `Izogibajte se`,
's690da6b432987c6f': `Samodejno varnostno kopiranje sprememb v trenutnem dokumentu. Spremembe se obnovijo ob ponovnem nalaganju programa WebWriter.`,
's69311c4e25074fb3': `Srednja šola`,
's697400b541fbc3cd': `Pod naslovom`,
's6988ab5d47593a26': `Imate najnovejšo različico programa WebWriter.`,
's69a49786a8009f43': `Poiščite pakete...`,
's69b12144dbb6544d': `Laotija`,
's69d88ef4b2618980': `Pokrov`,
's69fbbdb8ad2a084a': `Potemni`,
's6a31eff1ec4f71ad': `Skrij hrbtno stran (3D)`,
's6ac62e1c8c66f3bb': `Kompaktni superscr.`,
's6b585ba37cdb8260': `Dediči`,
's6b61f8abf89586be': `Hebrejščina`,
's6bd7a02fdf93e653': `Uskladitev vsebine`,
's6cfc66b824ea05ba': `Ostri robovi`,
's6d02dc19e21eb49c': `Vrh`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamski`,
's6d8b3b8047ed378d': `Način mešanja Mix`,
's6d8c02aee480af7a': `Meni`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Vstavljanje sloga`,
's6e288a119281f4c2': `Upodabljanje besedila`,
's6e4c20c6debcd5ca': `Po meri upravičiti`,
's6f84199e62584905': `Predoblikovano besedilo`,
's6fb3053e7244d326': `Druga področja`,
's70178e04a3b691b6': `Odprite nastavitve`,
's7031ca562378bde6': `Geometrijska natančnost`,
's7060970b5ed20a58': `Interaktivnost`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Prikaži nestabilne pakete`,
's71dec51005acc1e4': `Gosta vrstica`,
's72f2a02e2a5a4ee3': `Mediji`,
's730182ad28374cda': `Objekt`,
's731678e227a20559': `Ta naprava`,
's736904f276fbd441': `Naravoslovje`,
's739544d0c858c633': str`Ali pa spustite 
          ${0} tukaj 
        `,
's73cb20c838e761e1': `Izbira rezov`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Pixelated`,
's743f778233e42a3f': `Vstavite opombo`,
's744d993d03f29851': `Zaslon`,
's748c0074eff45884': `Manipulacija`,
's74aa0039a87141e2': `Elipsa`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Polje za polnjenje`,
's75109f5307578a61': `Dobrodošli v WebWriterju`,
's75a27f43413e02c5': `Francoski`,
's75d83fc3f0cfab40': `Naslov`,
's762e5704cc84089d': `Nastavitev drugih možnosti sloga izbranih elementov`,
's77318393dfdb0775': `Odstranitev vrstice`,
's77e594ddcc10c774': `Dovoliti komercialno uporabo?`,
's782eac2b3e80323d': `Izbor označite kot poudarjen`,
's782f286a79cca35d': `Relativni`,
's78673a3539cb1915': `Zgoraj levo`,
's78789724e789221c': `Velikost`,
's789ff24c8f03f1a4': `Razmik med črkami`,
's7995733bf97c01cc': `srbohrvaščina`,
's7a99528e7b64635a': `Okcitanščina`,
's7aaf0c06e69600f1': `Napaka z `,
's7ae49e142487766c': `Dostop do skupnosti`,
's7af555180b30a947': `Odprite orodja za razvijalce`,
's7b4ba250601b8667': `Vstavljanje predloge`,
's7b560d8693ed8f42': `Navpično`,
's7b9994904c4f5b54': `Tadžikistan`,
's7bdf0fd5b014d36c': `Velik pomen`,
's7beb1e77e82363eb': `razveljavitev zadnje spremembe v aktivnem dokumentu`,
's7c61118554a0ec36': `Največja vrednost (x)`,
's7c95876637f6a9d7': `Filter`,
's7cb4e55c59663b1c': `Podjetje`,
's7cfe12cd14df9950': `Odjavite se`,
's7d27db3c9639c6dd': `Nadomestni naslov`,
's7d8103f6f06f83d6': `Oblazinjenje`,
's7d864465dddbb50d': `Omogočite spreminjanje velikosti`,
's7de0e28d6c309a4e': `Omogočite dejanja na dotik`,
's7dea785045c3cc74': `Pritisnite novo kombinacijo tipk...`,
's7e0b179d4d1414eb': `Vnesite povezavo`,
's7e6570f2f1ae320f': `Sintetizirajte pisave`,
's7ecb1f29332293e5': `Izhodiščna raven izravnave`,
's7ed13ccddb1bf3c3': `Prekrivanje`,
's7edbe0b213199995': `Bachelor's`,
's7ede1c55e35ce9d6': `Simulacija`,
's7f09197a4814079b': `Nastavitev možnosti interaktivnosti za izbrane elemente`,
's7f326a142e856656': `Slog`,
's7fcb35d23be1e643': `Nabor polj`,
's80570196a9ce6d11': `Omogočite telemetrijo`,
's806f84eb0ace116e': `Oglejte si, kaj ste izbrali, in to spremenite. Kopirajte, izrežite, prilepite, pripnite ali spremenite postavitev. Ponuja različne možnosti glede na vašo izbiro, npr. oblikovanje besedila.`,
's80a42b81c52d4d8f': `Barva negovalnih znakov`,
's80b71fc6f43c5ce1': `Ohlapno`,
's812cbda653daaeba': `Ta funkcija še ni izvedena`,
's814d528c8af55807': `Element seznama definicij`,
's81c3d8809658b951': `Kašmirski`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Nadaljuj`,
's8247d32213e35f24': `Vstavite glavni`,
's82665b2ffabc9c0a': `Spletna stran`,
's828b1ecea8715884': `Pan (levo)`,
's833bd0422a7ef95d': `Velikost zavihka`,
's83420ad7b6a14db5': `Toggle Dev Tools`,
's83c15613b6f6f3c8': `Samo prek spleta`,
's83cd32b685ccc9b7': `Nadzor`,
's83f26d02dd7aa681': `Vidno`,
's840fa49e8989c028': `Položaj/oblika`,
's844a76d1843ceb3c': `Ponastavitev na privzeto vrednost`,
's84e4e8ae645b82ac': `Desno zgoraj (y)`,
's84e9c7f8785ca60b': `Vstavljanje obrazca`,
's8517ae4da104b004': `Skupina stolpcev tabele`,
's85186a61e0d55bac': `Videoposnetek`,
's851a7deea5984646': `Licenca Creative Commons OER?`,
's85f9aa6d3ea0e421': `Skupina noge tabele`,
's864b0e6270e97246': `Izbor označite kot stranski komentar`,
's8670e5ad3bf0dcf8': `Shrani kot`,
's8688d74dd3716d6e': `Bližnjice na tipkovnici za ukaze`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Rob oblike`,
's87cefc710b3567fb': `Vsebuje`,
's88676f992b2965db': `Raztegnite vsebino celic`,
's886897f2fd4edb99': `Skriti`,
's886c5db2a5579873': `Koncept`,
's888c71e8fcb916d3': `Samodejno shranjevanje`,
's88a62d29529948fb': `Vstavljanje tabele`,
's89950d86c8004d4b': `Preskočite brez prekrivanja`,
's89bca7498f20e041': `Klip za ozadje`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Prekinitev pred`,
's8a4ff2bd9c13498c': `Zapis`,
's8a6585c48ea104e9': `Skrijte prazne celice`,
's8a9eb438abac7c6a': `Etikete`,
's8b0432eecbd8b034': `Posodobitev`,
's8b7580c35e2aef87': `Levo zgoraj (y)`,
's8bc4affa761aa8a2': `Vstavljanje slike`,
's8c7f51cb067644c7': `Seznam podatkov`,
's8d342ecaa9e75b9b': `Odnos`,
's8d797888455f4147': `Prostori za odmor`,
's8d83386457e91813': `Razveljavite/opravite svoje spremembe ali si jih oglejte z vidika učenca.`,
's8d8643013a7754d1': `Poravnava besedila`,
's8df30fe2a50d3479': `Vstavite možnost prekinitve vrstice`,
's8e715248c3a78446': `Izrežite izbor`,
's8f29e48d6b9a1aa8': `Vstavite vrstico za glavo tabele`,
's8f4be9f086eb530f': `Razveljavi`,
's8f533296a536965e': `Shrani kot...`,
's8fad58c831ecf017': `Rubinova posoda za besedilo`,
's8ffe7abcbed8eb43': `Navpično, od leve proti desni`,
's90105521fcc40453': `Z računi WebWriter Cloud lahko dokumente shranjujete na spletu in jih delite z
          učenci. Dodajte račun tukaj in na voljo vam bo kot mesto za shranjevanje, nalaganje,
          deljenje in odpiranje dokumentov.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Paleta pisav`,
's90f7c1cf501ea0a7': `Barva dodge`,
's91093e0b087911ba': `Položaj s poudarkom`,
's919e1724f589c9b1': `Igralna reža`,
's91c5ed7769d00b65': `Vstavljanje vstavljanja`,
's9219acd5bef6269e': `Pod levo`,
's92548405912d46bf': `Poravnava premikanja (y)`,
's9258280591309342': `Poravnava premikanja (x)`,
's927d796559f49439': `Ozadje Izvor`,
's92b177e579ef7b97': `Poudarek`,
's92f846b9be2e8e8d': `Izbor označite kot poševni`,
's93566b84230af4f5': `Vstavljanje slike`,
's936aa0b239679585': `vstavite tematski prelom (običajno je prikazan kot vodoravna črta).`,
's9370dc6afa716b57': `Meja`,
's93f083e654a45715': `Bretonci`,
's94653c76b2d86a04': `Opredeljen rok`,
's9485af2e7cd9418f': `Osnovna šola`,
's94d2eee44b292567': `Preklapljanje naprednih možnosti`,
's94d61907ee22a8c1': `Korejski`,
's94eb1effbbb6498b': `Prelivanje`,
's951aa3a6439f1271': `Označevalnik seznama`,
's9565553d163fc92a': `Scenarij`,
's957787fc6b7ea5c0': `Pan (navzgor)`,
's95c161f68e5180a5': `Preverjanje izbora`,
's95d56e58f816d211': `Nizozemska`,
's95d8e41a64635c7c': `Beli prostor`,
's95de7e1eff6c053e': `Vodoravno, od zgoraj navzdol`,
's960d3a90ac199368': `Retijsko-romunski jezik`,
's96532132a29dd542': `Vstavljanje zvoka`,
's96a045dcade75ad0': `Gostota stolpca`,
's9781a5bb3fcb26a3': `Najprej izberite podjetje`,
's978522fbc9577a7e': `Somalijci`,
's97881699a2b21d5b': `Vrzel v vrstici`,
's97aa76056a81bd36': `Metrike`,
's986facb3ecc9602c': `Vstran, od desne proti levi`,
's987abd19fac8cf55': `Pod`,
's9896529e5cb20558': `Zunanja datoteka`,
's98977a87d1b93941': `Ponastavitev informacij, slogov in skript`,
's990d0e0fa2ab00b5': `Galicijski`,
's99229574e5692f19': `Grenlandija`,
's99a990f3841ad283': `Datoteke `,
's99b38e000175cc84': `Prečrtano`,
's99f110d27e30b289': `Naslov`,
's9ab10fbf4c7a7322': `Položaj podčrtavanja`,
's9abadcc828884d7b': `Besedišče`,
's9b7cd8860c8fc922': str`
          ${0}
          se prepiše. Ste prepričani? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Barva ozadja`,
's9c8df9626d152d5a': `Seznam definicij izraz`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Stolpec tabele`,
's9cf68f87b8e6122f': `Azerbajdžan`,
's9d167ef77aed79b6': `Sloj`,
's9d2d00982edafabb': `Turški`,
's9d430adc5be110e9': `Obratna vrstica`,
's9d54829be67943d3': `Medmrežje`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Izbris`,
's9df571714a1efb44': `Na voljo je samodejno shranjena različica te raziskovalne naloge. Ali jo želite naložiti?`,
's9e28faa598332e2b': `Vstavite videoposnetek`,
's9e3dbb678150edd4': `Nastavitev družine pisave`,
's9e40e59654c8ad67': `Stolpec`,
's9e85800d3700e31c': `Steza`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Različica pisave`,
's9f1ecdb3061d9cbc': `Ohranjanje prostorov`,
's9faf26107ed49fb9': `Vstavljanje celice tabele`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Prehod`,
's9ff3121d30f88d52': `Normalno`,
's9ffe1bbe64712bf1': `Platno`,
'sa00df4e39c72d3b4': str`
          ${0} ni podprta. 
        `,
'sa013e119fec906fb': `Vrstica`,
'sa01e7bf33563ef72': `Priponka za ozadje`,
'sa126cf8c627cec1e': `Upodabljanje slik`,
'sa13f72278add7513': `Pod pravico`,
'sa1647e3b36ec08d7': `Združite pokončno`,
'sa172190ea21f9b1c': `Dostopite do nastavitev, odprite raziskovalno napravo ali ustvarite novo.`,
'sa1c6c459b9b5115c': `Absolutno`,
'sa2cba871f6cdd99f': `Assamese`,
'sa2eff4dad1c119f1': `Predloga mreže`,
'sa30c12014e955946': `Ruski`,
'sa30f1981fd1cd441': `Velikost pisave`,
'sa311a24c1471a974': `Dokument`,
'sa352d168b262aa06': `Vstavljanje noge`,
'sa37fee6a52d18063': `Izbriši dokument`,
'sa39c7ac1d37f3bce': `označite izbor kot "dvosmerno izolacijo".`,
'sa3b4c01623211544': `Sila`,
'sa40fd43756fa8913': `Perzijski`,
'sa417644bef21a9aa': `Neimenovana tema`,
'sa43800e28be1bdbc': `Barva dekoracije`,
'sa477cb1825dceb3b': `Sudanski`,
'sa492a51a707930fa': `Vstavljanje blokovnega citata`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Napis na dnu`,
'sa50d3c35533f1d99': `Vsa polja`,
'sa53c5cb03a8fda50': `Izbor pripnite kot utrinek v paleti`,
'sa557ae6bee9148a6': `Napredek`,
'sa589e1df65dde0ec': `nastavite velikost, oblazinjenje in robove izbranih elementov`,
'sa5c371b4bb75e590': `Leva stran`,
'sa5c80e623459ffe4': `Vstavljanje glave`,
'sa5df1bcdba46c3fb': `Slika Naslov`,
'sa602e3fd3f2d98fd': `Animacija`,
'sa644d580d8a11e60': `Poravnava Rubina`,
'sa645d315510dc09e': `Izberite pot z diska`,
'sa65d4ad99f1d8c06': `Nastavitev ozadja besedila`,
'sa6607436f60ccc1a': `Estonski`,
'sa6f8d27bca557059': `Premikanje elementov meta/povezave/stila navzgor/navzdol v ta element`,
'sa757645ad842da97': `Ohranjanje odmorov`,
'sa75b95980cd80e78': `Urednik`,
'sa7698b3d20a6d1ec': `Pomikanje`,
'sa778acc33947c7b8': `Zaključek ture`,
'sa78a67272a4a6f95': `Matematična formula`,
'sa79167651dce1e80': `Nadomestno besedilo`,
'sa7af797a46c7d09a': `Spodnji del tabele`,
'sa7dbe35b758c138d': `Vstavljanje platna`,
'sa7dc6b8ef3f595dc': `Vstavljanje vira`,
'sa8279f8211b3950d': `Ohranjanje odmorov in prostorov`,
'sa8b55cab62e439b5': `Odstranitev stolpca`,
'sa8bbe0197d31b423': `Kratek opis`,
'sa9ff3b762365abe6': `Izvor transformacije (z)`,
'saa02e3762368ff35': `Izvor transformacije (y)`,
'saa065776236bfa28': `Izvor transformacije (x)`,
'saa33768e03c45fc8': `Velikost datoteke`,
'saaad98061a20ac39': `Vstavite matematično formulo`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Nadomestni nad`,
'saaec15c97a9e4245': `Obratni stolpec`,
'sab0c57df694a0a09': `Začetek obrezovanja`,
'sab4d9283896d9422': `Piksli ločljivosti Snap`,
'sab55faae8e165407': `Polnilo&lt;br&gt; kot vrzel`,
'sab5e7d2a069a2951': `Poklicni certifikat.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Poravnajte desno`,
'sac895c732f350ac5': `Dark`,
'saced41ddda8b2354': `Fleksibilna osnova`,
'sad190f86451081c0': `Nepali`,
'sad6be321164d08c8': `Kompaktna matematika`,
'sadd352cc7f6f2307': `Ob strani`,
'sae098810f946ca7c': `Tagalščina`,
'sae185e6af80ec81e': `Švedski`,
'sae1c7f13b7c0c47f': `Začetek`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Vstavite seznam opisov (glosar, seznam pojmov)`,
'saf3da7c95cb17260': `Izbor označite kot zgornji indeks`,
'saf440a0a592f2835': `Posodobitev na`,
'saf9e5134ba1a7d30': `Previjanje snap`,
'safc6f203342d09e2': `Preklopi predogled za aktivni dokument`,
'sb0a7e3adf4a125ee': `Desno zgoraj`,
'sb0a974028c99ca6d': `Omogočiti prilagoditve?`,
'sb0d4f0f7993cf085': `Nastavitev velikosti pisave`,
'sb0f3327210fe18fc': `Stolpci`,
'sb0f93c1c60c0249a': `Rubinasta osnova`,
'sb1494c08c8c720d1': `Nastavitev barve besedila`,
'sb19611adbc88f711': `Napredno: Prikažite ukaze za urejanje vira, npr. za prikaz HTML dokumenta ali dodajanje slogov in skript po meri.`,
'sb206d700d26b14ff': `Podčrtajte`,
'sb233557012dcb328': `Premaknite se navzdol`,
'sb26035b596566abf': `Neimenovani`,
'sb2cda80610c8d6ea': `Vesolje vse`,
'sb2dc787b0983ebc6': `Litvanski`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Center`,
'sb3ba3276ae93627c': `Vstavljanje vnaprej oblikovanega besedilnega bloka`,
'sb430f5b4824de0d3': `Izberite postavitev`,
'sb43db07b24da018a': `Amharščina`,
'sb45f9fb4dba6e71a': `Nenačrtovano`,
'sb4e003a459464d85': `Kurdski`,
'sb4f0310e6787d098': `Uzbek`,
'sb4f1dffbb6be6302': `Jasno`,
'sb51270e19988f9bd': `Regija`,
'sb59d621e3c93cc27': `Skupne meje celic`,
'sb5e9e1776242b028': `Interakcije`,
'sb60bc1250aad44c1': `Razpon`,
'sb60dd9d23d31ee66': `Doktorat`,
'sb6103872073d369e': `Vstavite podrobnosti`,
'sb616811735bfbafd': `Celica tabele`,
'sb628960829e223bb': `Preskočite vsa prekrivanja`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Uporaba in uvoz`,
'sb66e2181a7b5738a': `Z omogočanjem telemetrije dovolite zbiranje in hrambo podatkov v skladu z našimi`,
'sb67e0e7c0869f982': `Razlika`,
'sb68e83cda6c85af8': `Glava tabele`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Debelina dekoracije`,
'sb70c17f7899f9b01': `Latinščina`,
'sb71941f552f3504d': `Nastavitev posebne vrednosti`,
'sb740eab4afd5a710': `Samodejni pretok mreže`,
'sb741b6e0ca589122': `Vrnitev plasti`,
'sb7c77d0415de05cf': `Izvedba testov`,
'sb7fb7568f6883ab8': `Skupna raba aktivnega dokumenta`,
'sb85774dc5d18ff0f': `Potrdite`,
'sb85b1e36579852a6': `Nepravilna e-pošta ali geslo`,
'sb884fa76bfc55429': `Arabščina`,
'sb8a3d4df7d1c5e6b': `Bilanca`,
'sb8f610a0e8df91fc': `Svetlost`,
'sb8f855b49234b81b': `Uporabi`,
'sb905da066c10182c': `Plus temnejši`,
'sb940ade1bd81be7e': `Pod levo`,
'sb9e9a7dd45966756': `Izbor označite kot krepko`,
'sba509fd8ed61d1d5': `Neshranjena datoteka`,
'sba64d8954d027206': `Motnost`,
'sba88d90cd6c751b3': `Pravilo stolpca`,
'sbaf0a7c417e388af': `Zdravje`,
'sbb15d427ee1aa676': `Tigrinja`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filter za ozadje`,
'sbb85a407d730e13d': `Vstavljanje iskanja`,
'sbb86c6c96f598bb8': `Mešani`,
'sbba0156f795d8c07': `Urejanje izbora`,
'sbba865d4b437944f': `Atribut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Odstranitev`,
'sbc5f2a81604baf9b': `Naslov 6`,
'sbc5f2b81604bb14e': `Naslov 5`,
'sbc5f2c81604bb301': `Naslov 4`,
'sbc5f2d81604bb4b4': `Naslov 3`,
'sbc5f2e81604bb667': `Naslov 2`,
'sbc6953a36ced943f': `politika zasebnosti`,
'sbd181cd54b8402a4': `Urejanje izbora`,
'sbd35ee879d9cf770': `Besedilo Rubin`,
'sbd40f40cbadd38d5': `Odstranitev tega paketa gradnikov`,
'sbd72dc858de95ce8': `Burmanski`,
'sbe3c60c65f129daa': `Humanistika`,
'sbe4a7c8f231739b3': `ali prilepite/spustite/izberite datoteko`,
'sbe90de083557ef3e': `Svahili`,
'sbefb6064cba01844': `Vstavljanje preloma vrstice`,
'sbf00e1ee999ea94e': `Vstavljanje skripte`,
'sbf519920c2017d67': `Viseči`,
'sbfa01f189a68d3e9': `Fleksibilna rast`,
'sbff54e740c4086eb': `Prikaži neznane pakete`,
'sbfff51feacf30196': `Sanskrt`,
'sc0ceaa9843510f67': `Turkmen`,
'sc1611c0558728a2a': `Položaj`,
'sc1a155cc25899250': `Skupina vrstic tabele`,
'sc1aa1f6051b7102a': `Romunski`,
'sc1edebeaef92b7bd': `Določena postavitev tabele`,
'sc1fff4f356dfb2fb': `Preoblikovanje`,
'sc24bda3c061fddf8': `Območje s klikom`,
'sc252a4e091763606': `Vstavljanje noge tabele`,
'sc2536e077514accc': `Premikanje`,
'sc275dd00036d16cb': `Značaj citatov`,
'sc28864200d2a3799': `Kopiranje kode QR kot slike`,
'sc2a24a9dd41a9503': `Linija za dekoracijo`,
'sc2b734cca2fa643b': `Pan (navzdol)`,
'sc2e2a0dbf03723b7': `Napredno: V upravitelju paketov prikaže pakete iz neznanih virov (Opozorilo: lahko je nevarno)`,
'sc3998b77d72c2932': `Vstavite spletno mesto (kot vdelani okvir)`,
'sc3ac225273c8316b': `Splošno`,
'sc3cfee84dbbf36ae': `Lokalna datoteka`,
'sc3f09a9b6fa4fbed': `Notranjost`,
'sc43767deea72e9f3': `Seznam opisov`,
'sc462bbdd36bcba6b': `Referenčno polje`,
'sc4ee3e4ee994dafd': `Ukrajinski`,
'sc50d09edf9325339': `Dialog`,
'sc52b67794c06a0d3': `Izvor perspektive (y)`,
'sc52e8b794c0913d6': `Izvor perspektive (x)`,
'sc53de149fcaad713': `Medbesedilni odnosi`,
'sc546f489f9c0cced': `Preklopi način testiranja za aktivni dokument`,
'sc5bcf50d1b578d9f': `Nastavitve funkcije pisave`,
'sc5cb39478b9b7625': `Označite izbor kot indeks`,
'sc6415b50ff928294': `Postavka seznama`,
'sc650ff15b20fe9d3': `Obračanje (z)`,
'sc6578b15b2154365': `Obračanje (x)`,
'sc65aff15b2183e58': `Obračanje (y)`,
'sc6da0f4a7e4d710e': `Prekrivanje jezika pisave`,
'sc74e3567875ce255': `Tako oznaka vašega gradnika kot ime vašega paketa NPM`,
'sc7eb080b96e244df': `Malajščina`,
'sc8ac7ef92b95df3f': `Premik (x)`,
'sc8af536e2084ade0': `Paleta`,
'sc8b022f92b992bc2': `Premik (y)`,
'sc8b39af92b9c2d81': `Premik (z)`,
'sc8d2c7f6c33a2b32': `nastavitev sloga besedila (poravnava, odmik, razmik itd.) izbranih elementov`,
'sc8fa0e3de389ef1c': `Prilagoditev velikosti pisave`,
'sc9474bf7a0668d73': `Povzetek`,
'sc94e314312a8900c': `Češki`,
'sc980855a000b76ea': `Dno`,
'sc98b103772de63f4': `Finska`,
'sca7cfe2bef51b2a5': `Korenina`,
'sca7fed2bef53cb99': `Vloga`,
'scabe6ecee5e01fd2': `Malteški`,
'scace301a88231cce': `Vstavite`,
'scbc55f622ec078c1': `Ogled škatle`,
'scbe537fc38ff4c13': `Samodejni stolpci v mreži`,
'scc1db59d292cbc4c': `Oddelek`,
'scc56b218a2689c42': `Armenski`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Polje za oblazinjenje`,
'scd9cedeb5ece3adb': `Podčrtaj`,
'scdf536b65be39ec5': ` Ustvarjanje/uvoz`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografski`,
'sceecdd0bb404bc17': `Vstavitev skupine možnosti`,
'scf00d48fd5953a03': `Grški`,
'scf932840a69dbb7c': `Portugalska`,
'scf932a8577057752': `Stopka`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Desno spodaj`,
'sd01178c54f648118': `Stebri za ravnotežje`,
'sd03bff50f87f82d4': `Znak za podčrtaje`,
'sd05a155fe09c2866': `Na spletu, ko uporabljate`,
'sd0864ea6cb6ef22e': `Skupnost`,
'sd10fdbe6caf9a998': `Prekinitev vrstice`,
'sd121d3b959b7888d': `Optimizacija hitrosti`,
'sd1a78e667a1a139f': `označite izbor kot vstavljanje`,
'sd1cffad290ea5b3b': `Ohranite vse`,
'sd1f10284eeb17b25': `Fidži`,
'sd1f44f1a8bc20e67': `E-pošta`,
'sd1f81984eeb7c0e8': `Napolnite`,
'sd29dc07235eea0f5': `Ponudba`,
'sd2addf69477cd4b4': `Uvozni paket`,
'sd2ed26defc646d47': `Filter za ozadje`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Določeno`,
'sd3a288c1094b8a63': `Širina pravila stolpca`,
'sd3c65ef5c380c046': `Vstavljena stran`,
'sd3dcb76f7b28adb8': `Latvijski`,
'sd3eca1e0f4209f6e': `Vse obrezati`,
'sd3f402df8619ddcd': `Ti podatki o vas se samodejno dodajo novim dokumentom. V urejevalniku metapodatkov
          lahko to spremenite za vsak dokument.`,
'sd4368b12645d3c0f': `Vstavljanje portala`,
'sd452cebf4a0313d1': `Prikaži ukaze za urejanje vira`,
'sd48cc52117f4d68b': `Italijanski`,
'sd52660ee947ca58b': `Vstavljanje stolpca tabele`,
'sd588d17a1b25c220': `Prelivanje besedila`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Višja izobrazba.`,
'sd5cf95145e4d89ca': `Odpiraj ta utrinek`,
'sd5fd9d11a92f5b1d': `Levo spodaj (y)`,
'sd60c9bbc51375635': `Vstavljanje gumba`,
'sd66c4767fa3dde28': `Barva poudarka`,
'sd679c8b1bf8cc8a5': `Majhne kapice`,
'sd7086c4425c53c80': `Družina pisav`,
'sd837f42ac7cbfb58': `Oblika (zunaj)`,
'sd88076d2994ee0fb': `Izključitev`,
'sd89a2e529b31ef43': `Obrnite`,
'sd8a345e95668b73b': `Navpično, od desne proti levi`,
'sd8ce9e57270b030d': `Raztezanje pisave`,
'sd8ecf227c7c49331': `Matematični`,
'sd8f923198e0c5c6a': `Konec`,
'sd9c21e5f60d6bdd8': `Danska`,
'sd9ff8e2612e63d50': `Velikost okvirja`,
'sda2d76b976502a8d': `Odprto...`,
'sda344aacb837387e': `Položaj v zabojniku`,
'sda5b6fa8b771f996': `Plavati levo`,
'sda9254d1f1228e1a': `Madžarski`,
'sdb1595f5c742dfbb': `Vhod`,
'sdb711380a28fec75': `Vstavite seznam (urejen)`,
'sdb73788b3c975f16': `Samodejno`,
'sdbee7e0523a23a42': `Desno spodaj (y)`,
'sdc48456f9a27ae02': `Generator`,
'sdc70d81cf6c28533': `Gruzijski`,
'sdd1ff479d04ac140': `Javna stran`,
'sdd2fc8919a9c3111': `Način mešanja ozadja`,
'sdd35b688281b6dea': `Japonski`,
'sddc49047f66a64ab': `Opis ni na voljo`,
'sdef34fe08bb28b09': `Kitajščina (poenostavljena)`,
'sdf62e305e1594805': `Izbor označite z opombo ruby`,
'sdf946172dfa0328f': `Nadpis`,
'sdf9bc5d9b7f3e3de': `Uskladitev`,
'se036b53f145441cd': `Mešana vsebina`,
'se06f459fccdc3ce9': `Poravnava zadnje vrstice besedila`,
'se0a782a8be8e018b': `Norveški`,
'se0cda6b80a1bb50f': `Slovaška`,
'se0f67eae944f8f94': `Izklopite glasnost`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Člen`,
'se1f5bb0386c88f96': `nastavi barvo izbranega besedila`,
'se219da7b1e955c65': `Jasno oblikovanje`,
'se25e4f2cb77b8be8': `Jezik za vmesnik WebWriter in novi dokumenti`,
'se2796c5824ec8916': `Vidnost vsebine`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Anywhere`,
'se39c065efa467782': `Baskije`,
'se3b4c857f91f80d7': `Bližnjice na tipkovnici`,
'se47baf2fd16b9d2b': `Predloga`,
'se48bd9e6c2a3109d': `Računi`,
'se58467472725ad0c': `Ločljivost slike`,
'se58f06c2b0583ff7': `Izberite koordinate`,
'se5dc1e97fb743ade': `Razmik`,
'se619a501d1bfe6a5': `Zaviti`,
'se62385ac082368d2': `Izbor označite kot vir navedbe`,
'se6297163cac9d276': `Uredi vir`,
'se633223a0b88625e': `Razporeditev celic`,
'se638417c560cfe5c': `Vstopite v notranjost`,
'se64f418b4e733b6c': `Vstavite izhod`,
'se6cdad455e2d8c02': `Vstavite delitev`,
'se79c0a3ac70d8fb3': `Asp. razmerje (x)`,
'se79fae3ac710dc36': `Razmerje Asp. (y)`,
'se7fad370d8fb4cec': `Optimizacija čitljivosti`,
'se8a94b4effa2033e': `Abecedno`,
'se95d4e55ea186d9a': `Barva drsne vrstice`,
'se96d43a515b8451c': `Slovenski`,
'se96fd76ba1b2975a': `Osrednji`,
'se9ac05f36b004eb0': `Skrijte uvodni ogled. Onemogočite, da se ogled ponovno prikaže.`,
'se9b1fec72ffd8f48': `Lokalni`,
'sea24bdcaa2bd2dec': `Obvezen posnetek`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Preklopi urejevalnik metapodatkov`,
'sea896ed51ad33287': `Posebni slogi niso na voljo`,
'seaaaeb09e3b4e78b': `Ukazi za urejanje`,
'seabae79729c4b2ad': `Preklopite e-pošto`,
'seaecc8267bad6234': `Srednja šola`,
'seaf97719986faf4f': `Vrzel`,
'seb19675a580f0628': `Izogibajte se stolpcu`,
'seb4e52ef5ec7a7dc': `Barve/učinki`,
'seb8982ae8c3cdcc5': `Indonezijski`,
'sebbced89e0db2894': `Prvo izhodišče`,
'sec02109a0dd2a6c8': `Poudarjena barva`,
'sec2557a35b702525': `Spremenljivka`,
'sec2da4aa7a02b925': `Islandski`,
'sec30fbb20f102670': `Vstavite povzetek`,
'sec8b0b6c729816b6': `Naslovna skupina`,
'seccd05955adb76bc': `Plakat`,
'sed17285cd25d6389': `Imenik, v katerem se nahaja paket.json`,
'sed318ec045c5144f': `Več kot`,
'sed713f1b916fb469': `Razmik med robovi (x)`,
'sed74a31b9172942c': `Razmik med robovi (y)`,
'sed86bd0deb2e5372': `Preoblikovanje besedila`,
'see2fcaedf9743ec6': `Lokacija`,
'seec6798afe90ffc8': `Natisni`,
'sef00c258bc1ecf1e': `V tem raziskovalnem gradivu so nespremenjene spremembe.`,
'sef23dd271edd4a8b': `Levo spodaj`,
'sef24caccbd4645ef': `Krčenje Flex`,
'sef49aec68fd1dc66': `Ime`,
'sef73fe18e351eb35': `Ključne besede`,
'sef75f458d77491af': `Skupina možnosti`,
'sefcf950b3cc4fc3b': `Jezik`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Vsebina`,
'sf0cab2483f66aa2e': `Po meri`,
'sf0e261e04eda82ff': `Videz`,
'sf1045382c1fd9a85': `Natančne barve tiskanja`,
'sf14c35392ec7bf10': `Ta funkcija v brskalniku Firefox ni na voljo. Na voljo je v brskalnikih Chrome ali Edge.`,
'sf14f9d5f9f6ca342': `Plus vžigalnik`,
'sf1868dc19e3917bb': `Španščina`,
'sf190149f9d8bbb2a': `Način pisanja`,
'sf1e79171c4856543': `Ste prepričani? Tega dejanja ni mogoče spremeniti, vse vaše nastavitve bodo
          izbrisane in ponastavljene.`,
'sf21c1f60c7515f44': `Izbor označite kot izhodni vzorec`,
'sf21fb4f4b9e8911f': `Širina`,
'sf22a3737146ec910': `Program WebWriter lahko vstavi SVG neposredno v dokument.`,
'sf2514d5dc78b1654': `Vstavljanje gradnika`,
'sf28903d4ca0ddcfc': `Odstranitev tega računa`,
'sf2ab37af0abc55ef': `Skrij uvodni ogled`,
'sf2bdb0b4d7b9c039': `Bengalščina`,
'sf2cbb5e519264e67': `Spremeni velikost vodoravno in navpično`,
'sf2d5cbc2fe0ad65a': `Lepljivo`,
'sf2d96d0eb32cb81f': `Sestava animacije`,
'sf2de3dbe2108637a': `Upodabljanje oblik`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Vstavljanje skladbe`,
'sf3c4da68b08a2590': `Malgaški`,
'sf471ec2496f904cc': `Zavrnite spremembe`,
'sf4849bc200e279ed': `Naslov tabele`,
'sf486ca1fdbe08645': `Vstavite sliko`,
'sf4b537d4cbd8f5fd': `Besedilo na vrhu`,
'sf4e0e02a5277ef23': `Vstavljanje besedilnega polja`,
'sf4f067d41efd4b83': `Lestvica (y)`,
'sf4f3cbd41f002b46': `Lestvica (x)`,
'sf4fa67d41f05a008': `Lestvica (z)`,
'sf5197db2d5f2926a': `Obračanje`,
'sf52d840949a980d1': str`
          ${0}
          bodo trajno izbrisani. Ste prepričani? 
        `,
'sf55d634dcc743595': `Storitve`,
'sf59c9081d106dd9c': `Označite izbor kot spremenljivko`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Brisanje dokumenta`,
'sf65df67a03bebe4b': `Obvezno za ta gradnik`,
'sf6673729c03ae999': `Ponastavitev programa WebWriter`,
'sf67571992e7dc88e': `Celotno obdobje`,
'sf6b4934598f7ed10': `Omogoči izbiro`,
'sf6e1665c7022a1f8': `Geslo`,
'sf79e0d78b56444f1': `Vrstni konec`,
'sf7a5f7a7c80c3082': `Obe spletni strani`,
'sf7c0eba7c822e3d6': `Krepko`,
'sf86bd4d2982f3b74': `Označi izbor kot kodo`,
'sf8e82313fa411494': `Izbor označite kot povezavo`,
'sf955eff73fb6b573': `Srbski`,
'sf9929e2d356260c5': `Pomnožite`,
'sf993bb199fefbe04': `Vse`,
'sf9ecf969dd4b8164': `Oba robova`,
'sf9f2c719a04066ec': `Aplikacija`,
'sfa49a5bb1a5d353e': `Zasebni dostop`,
'sfa59c7777e2a0eeb': `Vstavljanje seznama podatkov`,
'sfaa0a67db5c11f72': `Odmik prve vrstice besedila`,
'sfb231a52211b133f': `Brez ovijanja besedila`,
'sfb68cae41d749423': `Začetni`,
'sfb9b6edb0ed378c9': `Vir citiranja`,
'sfbbab09dbe553571': `Vstavite vektorsko risbo (SVG)`,
'sfc00292e778b67e2': `Merilnik`,
'sfc63e31ac7c956ed': `Izberite`,
'sfc815c9078bba30a': `Prenesite kodo QR kot sliko`,
'sfcdd8e672c75b713': `Naslov`,
'sfcebd18506f1e535': `Pretok`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Izhod`,
'sfdb1e4d90981a535': `Deljenje tega dokumenta`,
'sfdeef3dccf409f81': `Ta ključna beseda je potrebna za gradnike`,
'sfe6e758ad2603c1d': `Magistrski študij`,
'sfee1c12daf838935': `Barva gori`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Vstavljanje pogovornega okna`,
'sffa395f64ec6ac36': `Bolgarski`,
'sffdadf0a576fd802': `Višina`,
'spaceKey': `Prostor`,
'tabKey': `⭾ Tab`,
'upKey': `↑ navzgor`,
's2739460e44320108': `Chinese (Traditional)`,
'scbf29ce484222325': ``,
    };
  